<template>
  <div>
    <div class="page flex-col">
    <div class="box_1 flex-col">
      <!-- 头部导航组件 -->
      <HeaderNav />
      
      <div class="user-center-content flex-col">
        <div class="user-center-header flex-col">
          <h1 class="user-center-title">个人中心</h1>
        </div>
        
        <!-- 个人信息部分 -->
        <div class="user-info-section flex-col" v-if="userInfo">
          <div class="section-title flex-row">
            <span class="title-text">个人信息</span>
          </div>
          <div class="user-info-card flex-col">
            <div class="info-item flex-row">
              <span class="info-label">用户名：</span>
              <span class="info-value">{{ userInfo.username || '未设置' }}</span>
            </div>
            <div class="info-item flex-row">
              <span class="info-label">昵称：</span>
              <span class="info-value">{{ userInfo.nickname || '未设置' }}</span>
            </div>
            <div class="info-item flex-row">
              <span class="info-label">邮箱：</span>
              <span class="info-value">{{ userInfo.email || '未设置' }}</span>
            </div>
            <div class="info-item flex-row">
              <span class="info-label">余额：</span>
              <span class="info-value price">¥{{ formatPrice(userInfo.balance) }}</span>
            </div>
            <div class="info-item flex-row">
              <span class="info-label">注册时间：</span>
              <span class="info-value">{{ formatDate(userInfo.created_at) }}</span>
            </div>
          </div>
        </div>
        
        <!-- 加载状态 -->
        <div class="loading-section flex-col" v-if="loading">
          <p>加载中...</p>
        </div>
        
        <!-- 错误状态 -->
        <div class="error-section flex-col" v-if="!loading && !userInfo && error">
          <p>{{ error }}</p>
          <van-button type="default" @click="fetchUserInfo" class="retry-btn">重试</van-button>
        </div>
        
        <!-- 列表部分（暂时留空） -->
        <!-- <div class="list-section flex-col">
          <div class="section-title flex-row">
            <span class="title-text">我的人文下单列表</span>
          </div>
          <div class="empty-list flex-col">
            <p>功能开发中...</p>
          </div>
        </div> -->
        
        <div class="list-section flex-col">
          <div class="section-title flex-row">
            <span class="title-text">我的购墓订单</span>
          </div>
          <div class="empty-list flex-col" v-if="myOrderList.length === 0">
            <p>暂无购墓订单</p>
          </div>
          <div class="order-list flex-col" v-else>
            <div
              v-for="(item, index) in myOrderList"
              :key="item.id || index"
              class="order-item flex-col"
            >
              <div class="order-product-row flex-row">
                <img v-if="item.product?.cover" class="order-product-cover" :src="item.product.cover" :alt="item.product?.title || '产品'" referrerpolicy="no-referrer" />
                <div class="order-product-info flex-col">
                  <span class="order-product-title">{{ item.product?.title || '-' }}</span>
                  <div class="order-row flex-row justify-between">
                    <span class="order-no">订单号：{{ item.order_no || '-' }}</span>
                    <span class="order-status" :class="{ paid: String(item.pay_status) === '1', unpaid: String(item.pay_status) === '0' }">
                      {{ getPayStatusText(item.pay_status) }}
                    </span>
                  </div>
                  <div class="order-row flex-row justify-between">
                    <span class="order-price">金额：¥{{ formatPrice(item.price) }}</span>
                    <span class="order-created">下单时间：{{ item.created_at || '-' }}</span>
                  </div>
                  <div class="order-row flex-row" v-if="item.pay_time">
                    <span class="order-pay-time">支付时间：{{ formatPayTime(item.pay_time) }}</span>
                  </div>
                  <div class="order-row flex-row" v-else>
                    <span class="order-pay-time">支付时间：-</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="list-section flex-col">
          <div class="section-title flex-row justify-between">
            <span class="title-text">逝者列表</span>
            <van-button 
              type="primary" 
              size="small"
              @click="showAddAwayDialog = true"
              class="add-btn"
            >
              添加逝者
            </van-button>
          </div>
          <div class="empty-list flex-col" v-if="awayList.length === 0">
            <p>暂无逝者信息</p>
          </div>
          <div class="away-list flex-col" v-else>
            <div 
              v-for="(item, index) in awayList" 
              :key="item.id || index"
              class="away-item flex-row justify-between"
            >
              <div class="away-info flex-col">
                <span class="away-name">{{ item.name || '未命名' }}</span>
                <span class="away-date">添加时间：{{ formatDate(item.created_at) }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 添加逝者弹窗 -->
        <van-popup 
          v-model="showAddAwayDialog" 
          position="center"
          :style="{ width: '500px', padding: '30px' }"
        >
          <div class="add-away-form flex-col">
            <h3 class="form-title">添加逝者</h3>
            <van-field
              v-model="awayForm.name"
              label="姓名"
              placeholder="请输入逝者姓名"
              required
              :error-message="awayFormError.name"
            />
            <div class="form-actions flex-row">
              <van-button 
                type="default" 
                @click="showAddAwayDialog = false"
                class="cancel-btn"
              >
                取消
              </van-button>
              <van-button 
                type="primary" 
                @click="handleAddAway"
                :loading="addingAway"
                class="submit-btn"
              >
                确定
              </van-button>
            </div>
          </div>
        </van-popup>
      </div>
      
      <!-- 底部组件 -->
    </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getUserInfo, addAway, getAwayList, myOrder } from '@/api/home';
import { isLoggedIn } from '@/api/auth';

export default {
  name: 'UserCenter',
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      userInfo: null,
      loading: false,
      error: null,
      awayList: [], // 逝者列表
      showAddAwayDialog: false, // 显示添加逝者弹窗
      awayForm: {
        name: ''
      },
      awayFormError: {
        name: ''
      },
      addingAway: false, // 添加逝者中
      myOrderList: [] // 我的订单
    };
  },
  mounted() {
    // 检查登录状态
    if (!isLoggedIn()) {
      this.$router.push({
        path: '/login',
        query: { redirect: '/user-center' }
      });
      return;
    }
    this.fetchUserInfo();
    this.fetchAwayList();
    this.fetchMyOrders();
  },
  methods: {
    // 获取用户信息
    async fetchUserInfo() {
      this.loading = true;
      this.error = null;
      try {
        const res = await getUserInfo();
        if (res.code === 0 && res.data && res.data.user) {
          this.userInfo = res.data.user;
        } else {
          this.error = res.msg || '获取用户信息失败';
          if (res.code === 1 && res.msg === '登录失效') {
            // 登录失效，跳转到登录页
            this.$router.push({
              path: '/login',
              query: { redirect: '/user-center' }
            });
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.error = '获取用户信息失败，请稍后重试';
      } finally {
        this.loading = false;
      }
    },
    // 格式化价格
    formatPrice(price) {
      if (!price) return '0.00';
      const num = parseFloat(price);
      return num.toFixed(2);
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    },
    formatPayTime(ts) {
      if (!ts) return '-';
      const date = new Date(Number(ts) * 1000);
      if (Number.isNaN(date.getTime())) return '-';
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
    },
    getPayStatusText(payStatus) {
      return String(payStatus) === '1' ? '已支付' : '未支付';
    },
    // 获取逝者列表
    async fetchAwayList() {
      try {
        const res = await getAwayList();
        if (res.code === 0 && res.data && res.data.list) {
          this.awayList = res.data.list;
        } else {
          console.error('获取逝者列表失败:', res.msg);
          this.awayList = [];
        }
      } catch (error) {
        console.error('获取逝者列表失败:', error);
        this.awayList = [];
      }
    },
    // 获取我的订单（参数后续补充）
    async fetchMyOrders() {
      try {
        const res = await myOrder();
        if (res.code === 0) {
          const list = res?.data?.list;
          this.myOrderList = Array.isArray(list) ? list : [];
        }
      } catch (error) {
        console.error('获取我的订单失败:', error);
        this.myOrderList = [];
      }
    },
    // 添加逝者
    async handleAddAway() {
      // 验证表单
      this.awayFormError.name = '';
      if (!this.awayForm.name || !this.awayForm.name.trim()) {
        this.awayFormError.name = '请输入逝者姓名';
        return;
      }
      
      this.addingAway = true;
      try {
        const res = await addAway({
          name: this.awayForm.name.trim()
        });
        
        if (res.code === 0) {
          this.$toast.success('添加成功');
          this.showAddAwayDialog = false;
          this.awayForm.name = '';
          this.awayFormError.name = '';
          // 刷新逝者列表
          this.fetchAwayList();
        } else {
          this.$toast.fail(res.msg || '添加失败');
        }
      } catch (error) {
        console.error('添加逝者失败:', error);
        this.$toast.fail('添加失败，请稍后重试');
      } finally {
        this.addingAway = false;
      }
    }
  }
};
</script>

<style scoped>
.page {
  position: relative;
  width: 1920px;
  height: auto;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.box_1 {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 1920px;
  min-height: 100vh;
}

.user-center-content {
  width: 1200px;
  margin: 150px auto 0;
  padding: 40px 0;
}

.user-center-header {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2);
}

.user-center-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

.section-title {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 149, 151, 0.1);
  align-items: center;
}

.section-title.justify-between {
  justify-content: space-between;
}

.title-text {
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 149, 151, 1);
}

.user-info-section {
  margin-bottom: 40px;
}

.user-info-card {
  background-color: #f9f9f9;
  border: 1px solid rgba(0, 149, 151, 0.2);
  border-radius: 8px;
  padding: 30px;
  margin-bottom: 30px;
}

.info-item {
  margin-bottom: 20px;
  align-items: center;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 16px;
  color: #666;
  width: 120px;
  font-weight: 500;
}

.info-value {
  font-size: 16px;
  color: #333;
  flex: 1;
}

.info-value.price {
  color: rgba(169, 10, 6, 1);
  font-weight: bold;
  font-size: 18px;
}

.list-section {
  margin-bottom: 40px;
}

.empty-list {
  background-color: #f9f9f9;
  border: 1px solid rgba(0, 149, 151, 0.2);
  border-radius: 8px;
  padding: 60px 30px;
  text-align: center;
  color: #999;
  font-size: 16px;
}

.add-btn {
  background-color: rgba(0, 149, 151, 1);
  border-color: rgba(0, 149, 151, 1);
  color: #ffffff;
}

.away-list {
  background-color: #f9f9f9;
  border: 1px solid rgba(0, 149, 151, 0.2);
  border-radius: 8px;
  padding: 20px;
}

.order-list {
  background-color: #f9f9f9;
  border: 1px solid rgba(0, 149, 151, 0.2);
  border-radius: 8px;
  padding: 20px;
}

.order-item {
  padding: 14px 16px;
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid rgba(0, 149, 151, 0.1);
  gap: 8px;
}

.order-item:last-child {
  margin-bottom: 0;
}

.order-product-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.order-product-cover {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
}

.order-product-info {
  flex: 1;
  min-width: 0;
}

.order-product-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.order-row {
  align-items: center;
}

.order-no,
.order-price,
.order-created,
.order-pay-time {
  font-size: 14px;
  color: #666;
}

.order-status {
  font-size: 14px;
  font-weight: 600;
}

.order-status.paid {
  color: #07c160;
}

.order-status.unpaid {
  color: #ee0a24;
}

.away-item {
  padding: 15px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(0, 149, 151, 0.1);
  align-items: center;
}

.away-item:last-child {
  margin-bottom: 0;
}

.away-info {
  flex: 1;
}

.away-name {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin-bottom: 5px;
}

.away-date {
  font-size: 14px;
  color: #999;
}

.add-away-form {
  width: 100%;
}

.form-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0 0 20px 0;
  text-align: center;
}

.form-actions {
  margin-top: 30px;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn {
  padding: 10px 30px;
  color: rgba(0, 149, 151, 1);
  border-color: rgba(0, 149, 151, 1);
}

.submit-btn {
  padding: 10px 30px;
  background-color: rgba(0, 149, 151, 1);
  border-color: rgba(0, 149, 151, 1);
}

.loading-section,
.error-section {
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  color: #999;
  font-size: 16px;
}

.error-section {
  color: #f56c6c;
}

.retry-btn {
  margin-top: 20px;
  padding: 10px 40px;
  color: rgba(0, 149, 151, 1);
  border-color: rgba(0, 149, 151, 1);
}

.footer-wrapper {
  margin: 80px auto 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .page {
    width: 100%;
  }

  .box_1 {
    width: 100%;
  }

  .user-center-content {
    width: 100%;
    padding: 20px;
    margin-top: 100px;
  }

  .user-center-title {
    font-size: 24px;
  }

  .title-text {
    font-size: 20px;
  }

  .user-info-card {
    padding: 20px;
  }

  .info-label {
    width: 100px;
    font-size: 14px;
  }

  .info-value {
    font-size: 14px;
  }
}
</style>

